import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetLprDataAPI } from "api/lprApi";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

// ——— INITIAL STATE ———
const initialState = {
  statistics: {},
  lprData: [],
  loading: false,
  error: null,
  total: 0,
};

// ——— ASYNC THUNK ———
export const getLprStatistics = createAsyncThunk(
  "lprStatistics/getLprStatistics",
  async (params, { rejectWithValue }) => {
    try {
      const response = await GetLprDataAPI(params);
      // assume your API wraps data under `data`: { statistics, lprTableData }
      return response.data;
    } catch (err) {
      console.error("getLprStatistics error:", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

// ——— SLICE ———
const lprStatisticsSlice = createSlice({
  name: "lprStatistics",
  initialState,
  reducers: {
    // call `dispatch(clearLprStatistics())` before every new fetch
    clearLprStatistics(state) {
      state.statistics = {};
      state.lprData = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getLprStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLprStatistics.fulfilled, (state, { payload }) => {
        state.statistics = payload?.data?.statistics;
        state.lprData = payload?.data?.lprTableData;
        state.total = payload?.data?.total;
        state.loading = false;
        state.error = null;
      })
      .addCase(getLprStatistics.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Failed to fetch LPR statistics";
      }),
});

export const { clearLprStatistics } = lprStatisticsSlice.actions;
export default lprStatisticsSlice.reducer;
